
export default "/assets/computer-desktop-micro.9029d2aa.svg"